import '../index.css';

const About = () => {
  return (
        <div id='about' className='aboutUs'>
            <h1 data-translate="aboutUs1"  className='fadeOnScroll'>ABOUT</h1>
            <div className='aboutUsContainer'>
                <div data-translate="aboutUs2"  className='fadeOnScroll'>
                    We're a small game development studio based in Slovenia 🇸🇮, creating simple,
                    fun, and engaging games and gamified apps. Our focus is on turning ideas into playful digital
                    experiences that capture attention and spark enjoyment.
                </div>
                {/* <div className='fadeOnScroll'>
                    To craft fun, engaging games and gamified apps that captivate and entertain. Our goal is to make every
                    digital experience playful, interactive, and memorable - whether it's for learning, training, or just
                    pure enjoyment.
                </div> */}
            </div>
        </div>
  )
}

export default About